import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { cn } from '~/chords/lib/cn';

export function BreadcrumbsItem({
  to,
  children,
  ...delegatedProps
}: Omit<Partial<LinkProps>, 'className'>) {
  if (!to) {
    return (
      <span
        {...delegatedProps}
        aria-current="page"
        className={cn('break-all text-default')}
      >
        {children}
      </span>
    );
  }

  return (
    <Link
      {...delegatedProps}
      to={to}
      className={cn('underline duration-300 text-default hover:text-hover')}
    >
      {children}
    </Link>
  );
}

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
